import { render, staticRenderFns } from "./BasicsSupplierInformation.vue?vue&type=template&id=0a2eb373&scoped=true"
import script from "./BasicsSupplierInformation.vue?vue&type=script&lang=js"
export * from "./BasicsSupplierInformation.vue?vue&type=script&lang=js"
import style0 from "./BasicsSupplierInformation.vue?vue&type=style&index=0&id=0a2eb373&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2eb373",
  null
  
)

export default component.exports